/* eslint-disable no-plusplus */
export default function mapMovementCodesToObject(movementCodes) {
  const movements = {};
  for (let i = 0; i < movementCodes.length; i++) {
    movements[movementCodes[i].code] = 0;
  }
  return movements;
}
